import { render } from "./Captcha.vue?vue&type=template&id=2bd7f58f&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"

import "./Captcha.vue?vue&type=style&index=0&id=2bd7f58f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd7f58f"]])

export default __exports__